import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../services/axiosInstance';

export const fetchTermsOfService = createAsyncThunk('termsOfService/fetch', async (_, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.get('/terms-of-service');
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to fetch Terms of Service');
    }
});

export const createTermsOfService = createAsyncThunk('termsOfService/create', async (data, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.post('/terms-of-service', data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to create Terms of Service');
    }
});

export const updateTermsOfService = createAsyncThunk('termsOfService/update', async ({ id, data }, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.put(`/terms-of-service/${id}`, data);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to update Terms of Service');
    }
});

export const deleteTermsOfService = createAsyncThunk('termsOfService/delete', async (id, { rejectWithValue }) => {
    try {
        const response = await axiosInstance.delete(`/terms-of-service/${id}`);
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || 'Failed to delete Terms of Service');
    }
});

const termsOfServiceSlice = createSlice({
    name: 'termsOfService',
    initialState: {
        terms: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchTermsOfService.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchTermsOfService.fulfilled, (state, action) => {
                state.loading = false;
                state.terms = action.payload;
            })
            .addCase(fetchTermsOfService.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default termsOfServiceSlice.reducer;
